import { useEffect, useState } from "react";

interface ScreenSize {
  width: number;
  height: number;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}

/**
 * Custom hook to detect screen size and device type
 * Returns screen dimensions and device type flags
 */
export const useScreenSize = (): ScreenSize => {
  const [screenSize, setScreenSize] = useState<ScreenSize>(() => {
    // Initialize with current values
    if (typeof window !== "undefined") {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const userAgent = navigator.userAgent.toLowerCase();
      const isMobileDevice = /mobile|android|iphone|ipad|phone/i.test(
        userAgent
      );
      const isTouchDevice = "ontouchstart" in window;
      const isMobile = isMobileDevice || isTouchDevice;

      return {
        width,
        height,
        isMobile,
        isTablet: width >= 768 && width < 1024,
        isDesktop: width >= 1024,
      };
    }

    return {
      width: 0,
      height: 0,
      isMobile: false,
      isTablet: false,
      isDesktop: false,
    };
  });

  useEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const userAgent = navigator.userAgent.toLowerCase();
      const isMobileDevice = /mobile|android|iphone|ipad|phone/i.test(
        userAgent
      );
      const isTouchDevice = "ontouchstart" in window;
      const isMobile = isMobileDevice || isTouchDevice;

      console.log("isMobile: ", isMobile);

      setScreenSize({
        width,
        height,
        isMobile,
        isTablet: width >= 768 && width < 1024,
        isDesktop: width >= 1024,
      });
    };

    // Check on mount
    checkScreenSize();

    // Listen to resize events
    window.addEventListener("resize", checkScreenSize);

    // Cleanup
    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  return screenSize;
};
